import { InjectionToken } from '@angular/core';

/** EnovacomWsCredentialsGetter */
export type EnovacomWsCredentialsGetter = (...args) => string;
/** Enovacom basic authorization string */
export const ENOVACOM_WS_CREDENTIALS_GETTER = new InjectionToken<AnyFn>(
    'Enovacom basic authorization function to get string',
);
